import React, { useEffect, useState } from 'react';
import './Home.css';
import { Link } from 'react-router-dom';
import Header from './common/Header';
import FeaturedSection from './common/FeaturedSection';
import httpService from '../services/HttpService'; // Adjust the path based on your file structure
import { formattedPrice } from '../utils/priceFormatter';
import { Footer } from './common/Footer';

function Home() {
    const [sections, setSections] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        localStorage.removeItem('selectedFilters');
        localStorage.removeItem('selectedSorting');
        sessionStorage.clear();
        httpService.get('/home')
            .then(response => response.json())
            .then(data => {
                setSections(data);
                setLoading(false);
            })
            .catch(error => {
                console.error("Ошибка:", error);
                setError(error.message);
                setLoading(false);
            });
    }, []);

    if (loading) {
        // return <div>Loading...</div>;
        return <div></div>;
    }

    if (error) {
        return <div>Error: {error}</div>;
    }

    return (
        <div>
            <Header />
            <main className="home-main">
                {sections.map((section, index) => {
                    if (section.section_type === 'brand') {
                        return (
                            <FeaturedSection
                                key={index}
                                title={section.name}
                                buttonText={section.button}
                                imageUrl={section.main_image.link}
                                linkTo={`/brand/${section.id}`}
                                reverse={section.reverse}
                                btnLink={`/brand/${section.id}`}
                                modelId={section.main_image.model_id}
                            >
                                <p>{section.description}</p>
                            </FeaturedSection>
                        );
                    }

                    if (section.section_type === 'products') {
                        return (
                            <div key={index} className="products-section">
                                <div className="home-section-title">{section.title}</div>
                                <section className="home-featured-products">
                                    {section.products.map(product => (
                                        <div className="product-card" key={product.id}>
                                            <Link className="link" to={`/product/${product.id}`}>
                                                <div className="product-card-image-container">
                                                    <img
                                                        src={product.main_image?.link || "https://via.placeholder.com/150"}
                                                        alt={product.name}
                                                    />
                                                </div>
                                                <div className="product-brand-name">{product.brand.name}</div>
                                                <p>{product.name}</p>
                                                <p>{formattedPrice(product.price, product.actual_price, product.sale)}</p>
                                            </Link>
                                        </div>
                                    ))}
                                </section>
                            </div>
                        );
                    }

                    if (section.section_type === 'brands') {
                        return (
                            <div key={index} className="brands-section">
                                <h2 className="home-section-title">{section.title}</h2>
                                <section className="featured-stores">
                                    {section.products.map(brand => (
                                        <div className="store-card" key={brand.id}>
                                            <Link className="link" to={`/brand/${brand.id}`}>
                                                <img
                                                    src={brand.main_image.link || "https://via.placeholder.com/150"}
                                                    alt={brand.name}
                                                />
                                                <h3>{brand.name}</h3>
                                                <p>{brand.description}</p>
                                            </Link>
                                        </div>
                                    ))}
                                </section>
                            </div>
                        );
                    }

                    if (section.section_type === 'look') {
                        return (
                            <FeaturedSection
                                key={index}
                                title={section.name}
                                buttonText={section.button}
                                imageUrl={section.main_image.link}
                                linkTo={`/look/${section.id}`}
                                reverse={section.reverse}
                                btnLink={'/recommendations'}
                            >
                                <p>{section.description}</p>
                                <div className="look-products">
                                    {/* Uncomment and adjust if needed */}
                                    {/*{section.products.map(product => (*/}
                                    {/*    <Link key={product.id} to={`/product/${product.id}`} className="product-link">*/}
                                    {/*        <p className="home-look-item">- {product.name} <strong>({product.brand.name})</strong> {product.price} руб.</p>*/}
                                    {/*    </Link>*/}
                                    {/*))}*/}
                                </div>
                            </FeaturedSection>
                        );
                    }

                    return null;
                })}
            </main>
            <Footer />
        </div>
    );
}

export default Home;